module.exports = __webpack_public_path__ + "static/poohvaleriekevinbretteatingwaffle-df176cf989965f379de7c7d8f7adc731.jpg";